import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/login")({
	// biome-ignore lint/suspicious/noExplicitAny: TODO
	validateSearch: (search: Record<string, any>): { encode?: string } => ({
		encode: search?.encode,
	}),
});
